<template>
    <SettingsSection :section="section" :index="index" :level="level" :isLoading="isLoading" :initiated="initiated"
        @debounceSave="debouncedAutoSave()" @instantSave="saveSettings">
        <template v-slot:prepend-settingList>
            <TimeRoundingVisualizer :initiated="initiated" :minimumMinutes="minimumMinutes"
                :incrementMinutes="incrementMinutes" :thresholdMinutes="thresholdMinutes" :isForWork="isForWork"
                :isSaving="isLoading">
            </TimeRoundingVisualizer>
        </template>
    </SettingsSection>
</template>


<script>
import SettingsConstants from '@/helpers/Constants/SettingsConstants';
import Section from "./Section.js"
import TimeRoundingVisualizer from './TimeRoundingVisualizer.vue';
const SettingsSection = () => import("./SettingsSection.vue");

export default {
    name: "TimeRoundingSection",
    props: {
        section: Section,
        index: Number,
        level: Number,
        isLoading: Boolean,
        initiated: Boolean,
    },
    components: {
        SettingsSection,
        TimeRoundingVisualizer,
    },
    mixins: [],

    data() {
        return {};
    },

    methods: {
        getMinuteSettingByKey(key) {
            if (!this.initiated) {
                return 0;
            }
            var setting = this.section?.settingList.find(x => x.settingKey == key);
            return parseInt(setting.value);
        },

        saveSettings(settingsArr) {
            this.$emit('instantSave', settingsArr)
        },

        debouncedAutoSave() {
            this.$emit('debounceSave')
        },
    },

    computed: {
        isForWork() {
            return this.section.key.includes('Work');
        },
        relevantKeys() {
            if (this.isForWork) {
                return {
                    increment: SettingsConstants.TimeReportWorkTimeRounding.settingKey,
                    minimum: SettingsConstants.TimeReportWorkMinValueTimeRounding.settingKey,
                    incurred: SettingsConstants.TimeReportWorkTimeMinutesIncurred.settingKey,
                }
            }
            else {
                return {
                    increment: SettingsConstants.TimeReportDriveTimeRounding.settingKey,
                    minimum: SettingsConstants.TimeReportDriveMinValueTimeRounding.settingKey,
                    incurred: SettingsConstants.TimeReportDriveTimeMinutesIncurred.settingKey,
                }
            }
        },

        minimumMinutes() {
            var key = this.relevantKeys.minimum;
            return this.getMinuteSettingByKey(key);
        },
        incrementMinutes() {
            var key = this.relevantKeys.increment;
            return this.getMinuteSettingByKey(key);
        },
        thresholdMinutes() {
            var key = this.relevantKeys.incurred;
            return this.getMinuteSettingByKey(key);
        },
    },

    watch: {},
};
</script>


<style lang="scss" scoped></style>